import { LinkTarget } from "./linkTarget";
import { OPERATIONS_PATH, operationsLink } from "./operationsDeepLink";
import { STOPPAGES_PATH, stoppagesLink } from "./stoppagesDeepLink";

export const OPERATIONS_AREA = "Operations";
export const STOPPAGES_AREA = "Stoppages";

export const PRODUCTION_LIST_TARGET: LinkTarget = { to: "/production/list", area: "DiggingLoadingSummary" };
export const OPERATIONS_TARGET: LinkTarget = { to: OPERATIONS_PATH, area: OPERATIONS_AREA };
export const STOPPAGES_TARGET: LinkTarget = { to: STOPPAGES_PATH, area: STOPPAGES_AREA };
export const PRODUCTION_REHANDLE_TARGET: LinkTarget = { to: "/production/rehandle", area: "GeologyRehandle" };
export const PRODUCTION_CRUSHING_TARGET: LinkTarget = { to: "/production/crushing", area: "GeologyCrushing" };

export const MATERIAL_MOVEMENT_TARGETS: Record<"production" | "inPit" | "rehandle" | "crushing", LinkTarget> = {
  production: PRODUCTION_LIST_TARGET,
  inPit: PRODUCTION_LIST_TARGET,
  rehandle: PRODUCTION_REHANDLE_TARGET,
  crushing: PRODUCTION_CRUSHING_TARGET,
};


export const operationsMachineTarget = (plantRef?: string | null, plantId?: number | null): LinkTarget | null =>
  plantRef ? { to: operationsLink({ machine: plantRef, plantId }), area: OPERATIONS_AREA } : null;

export const stoppagesMachineTarget = (plantRef?: string | null): LinkTarget | null =>
  plantRef ? { to: stoppagesLink({ machine: plantRef }), area: STOPPAGES_AREA } : null;

export const productionPatternTarget = (diggingPatternId?: number | null): LinkTarget | null =>
  diggingPatternId ? { to: `/production/show?diggingPatternId=${diggingPatternId}`, area: "Production" } : null;

export const drillingEntryTarget = (drillingId?: number | null): LinkTarget | null =>
  drillingId ? { to: `/db/bh-drilling?drillingId=${drillingId}`, area: "BlastHoleDrilling" } : null;

export const drillingRigTarget = (plantId?: number | null): LinkTarget | null =>
  plantId ? { to: `/db/bh-drilling?rigId=${plantId}`, area: "BlastHoleDrilling" } : null;

export const blastPatternTarget = (patternBlastId?: number | null): LinkTarget | null =>
  patternBlastId ? { to: `/db/blasts/pattern/${patternBlastId}`, area: "BlastPattern" } : null;

export const EXPLOSIVES_STORE_TARGET: LinkTarget = { to: "/db/explosives", area: "ExplosivesStore" };
